(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[422],{

/***/ 13954:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(90908);
var icon = __webpack_require__(33634);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(96742);
__webpack_require__(24774);

const Copy = 'M6.52071 6.28783C6.52071 3.91973 8.44037 2 10.8084 2H17.7123C20.0803 2 22 3.91973 22 6.28784V13.1921C22 15.5602 20.0803 17.4799 17.7123 17.4799H10.8084C8.44036 17.4799 6.52071 15.5602 6.52071 13.1921V6.28783ZM10.8084 4.14392C9.62437 4.14392 8.66454 5.10378 8.66454 6.28783V13.1921C8.66454 14.3761 9.62437 15.336 10.8084 15.336H17.7123C18.8963 15.336 19.8562 14.3761 19.8562 13.1921V6.28784C19.8562 5.10378 18.8963 4.14392 17.7123 4.14392H10.8084ZM4.994 7.6477C5.37807 8.09823 5.3242 8.77482 4.87369 9.1589C4.42536 9.54112 4.14383 10.1066 4.14383 10.7389L4.14384 17.7121C4.14384 18.8962 5.10369 19.8561 6.28767 19.8561H13.2607C13.893 19.8561 14.4584 19.5745 14.8406 19.1262C15.2247 18.6757 15.9012 18.6218 16.3517 19.0059C16.8022 19.39 16.8561 20.0666 16.472 20.5171C15.6999 21.4228 14.5471 22 13.2607 22H6.28767C3.91963 22 2 20.0802 2 17.7121L2 10.7389C2 9.45237 2.57715 8.29955 3.48287 7.52739C3.93338 7.14331 4.60994 7.19717 4.994 7.6477Z';
const IconCopy = lib.variant('IconCopy', icon.Icon, {
    path: Copy,
});

exports.v = IconCopy;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 30577:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(90908);
var icon = __webpack_require__(33634);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(96742);
__webpack_require__(24774);

const LINK = 'M3.9,12C3.9,10.29 5.29,8.9 7,8.9H11V7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H11V15.1H7C5.29,15.1 3.9,13.71 3.9,12M8,13H16V11H8V13M17,7H13V8.9H17C18.71,8.9 20.1,10.29 20.1,12C20.1,13.71 18.71,15.1 17,15.1H13V17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7Z';
const IconLink = lib.variant('IconLink', icon.Icon, {
    path: LINK,
});

exports.J = IconLink;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 17471:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(90908);
var icon = __webpack_require__(33634);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(96742);
__webpack_require__(24774);

const MINUS = 'M6 12.75L6 11.25L18 11.25V12.75L6 12.75Z';
const IconMinus = lib.variant('IconMinus', icon.Icon, {
    path: MINUS,
});

exports.U = IconMinus;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 4436:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(90908);
var icon = __webpack_require__(33634);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(96742);
__webpack_require__(24774);

const SHARE = 'M18 16.1205C18.512 16.1205 18.992 16.253 19.44 16.5181C19.888 16.7831 20.244 17.1406 20.508 17.5904C20.772 18.0402 20.904 18.5221 20.904 19.0361C20.904 19.5502 20.772 20.0361 20.508 20.494C20.244 20.9518 19.888 21.3173 19.44 21.5904C18.992 21.8635 18.512 22 18 22C17.488 22 17.008 21.8635 16.56 21.5904C16.112 21.3173 15.756 20.9518 15.492 20.494C15.228 20.0361 15.096 19.5502 15.096 19.0361C15.096 18.7149 15.112 18.498 15.144 18.3855L8.064 14.241C7.488 14.7711 6.8 15.0361 6 15.0361C5.472 15.0361 4.976 14.8996 4.512 14.6265C4.048 14.3534 3.68 13.9839 3.408 13.5181C3.136 13.0522 3 12.5542 3 12.0241C3 11.494 3.136 10.996 3.408 10.5301C3.68 10.0643 4.048 9.69478 4.512 9.42169C4.976 9.14859 5.472 9.01205 6 9.01205C6.8 9.01205 7.488 9.27711 8.064 9.80723L15.096 5.71084C15.032 5.38956 15 5.15663 15 5.01205C15 4.48193 15.136 3.98394 15.408 3.51807C15.68 3.05221 16.048 2.68273 16.512 2.40964C16.976 2.13654 17.472 2 18 2C18.528 2 19.024 2.13654 19.488 2.40964C19.952 2.68273 20.32 3.05221 20.592 3.51807C20.864 3.98394 21 4.48193 21 5.01205C21 5.54217 20.864 6.04016 20.592 6.50602C20.32 6.97189 19.952 7.34136 19.488 7.61446C19.024 7.88755 18.528 8.0241 18 8.0241C17.264 8.0241 16.576 7.74297 15.936 7.18072L8.904 11.3253C8.968 11.6145 9 11.8394 9 12C9 12.1606 8.968 12.4016 8.904 12.7229L16.032 16.8675C16.608 16.3695 17.264 16.1205 18 16.1205Z';
const IconShare = lib.variant('IconShare', icon.Icon, {
    path: SHARE,
});

exports.F = IconShare;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 32311:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71297);

var ReviewPrompt = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "reviews";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | reviews */ 912).then(__webpack_require__.bind(__webpack_require__, 60040));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(60040);
        }
        return eval("require.resolve")("./prompt");
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (ReviewPrompt);


/***/ }),

/***/ 93984:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": () => (/* binding */ ListPage)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(50238);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-down/index.js
var chevron_down = __webpack_require__(34783);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/copy/index.js
var copy = __webpack_require__(13954);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/plus/index.js
var plus = __webpack_require__(31903);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/popover/index.js
var popover = __webpack_require__(31744);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/components/action-buttons/compare/index.tsx + 1 modules
var compare = __webpack_require__(58917);
// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(65634);
// EXTERNAL MODULE: ./src/components/expert-user-label/index.tsx
var expert_user_label = __webpack_require__(32358);
// EXTERNAL MODULE: ./src/components/user-avatar/index.tsx + 1 modules
var user_avatar = __webpack_require__(60738);
// EXTERNAL MODULE: ./src/hooks/use-rebranding.ts
var use_rebranding = __webpack_require__(91538);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(95088);
// EXTERNAL MODULE: ./src/components/spinner/index.ts + 2 modules
var spinner = __webpack_require__(61061);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/alert.js
var actions_alert = __webpack_require__(33944);
// EXTERNAL MODULE: ./src/areas/sidebar/components/item-list/list-item.tsx + 12 modules
var list_item = __webpack_require__(95935);
// EXTERNAL MODULE: ./src/areas/sidebar/components/sort-button/index.tsx + 1 modules
var sort_button = __webpack_require__(27507);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/areas/list-page/components/apps-banner/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    flex-direction: column;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    justify-content: center;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  background-image: url(",
        ");\n  background-position: center;\n  border-radius: ",
        ";\n\n  display: flex;\n  gap: ",
        " ",
        ";\n  ",
        ";\n\n  padding: ",
        ";\n  margin-bottom: ",
        ";\n\n  align-items: center;\n  justify-content: space-between;\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    gap: ",
        "\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var StyledRoot = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledRoot",
    componentId: "sc-0-0"
})(_templateObject2(), function(props) {
    return props.bannerBackgroundUrl;
}, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* media.smallOnly */.BC.smallOnly(_templateObject()), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing250 */.bK.measurements.spacing250, base/* media.mediumOnly */.BC.mediumOnly(_templateObject1()));
var StyledCenteredTexts = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledCenteredTexts",
    componentId: "sc-0-1"
})(_templateObject3());
var StyledAppIconsWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledAppIconsWrapper",
    componentId: "sc-0-2"
})(_templateObject5(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(_templateObject4(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150));

// EXTERNAL MODULE: ./src/areas/list-page/constants.ts
var constants = __webpack_require__(39563);
;// CONCATENATED MODULE: ./src/areas/list-page/components/apps-banner/app-download-button.tsx



var HEIGHT = 36;
var WIDTH = 128;
var REL = "noreferrer noopener";
var TARGET = "_blank";
var imgSrc = function(market, store) {
    return "".concat(market.cdn, "/g/misc/").concat(store, "-").concat(market.code, ".png");
};
var AndroidAppDownloadButton = function() {
    var market = (0,app_context/* useAppContext */.bp)().market;
    return /*#__PURE__*/ react.createElement("a", {
        href: constants/* appsConfig.android.storeUrl */.K.android.storeUrl,
        target: TARGET,
        rel: REL
    }, /*#__PURE__*/ react.createElement("img", {
        src: imgSrc(market, "googleplay"),
        alt: "Google Play",
        width: WIDTH,
        height: HEIGHT
    }));
};
var IOSAppDownloadButton = function() {
    var market = (0,app_context/* useAppContext */.bp)().market;
    return /*#__PURE__*/ react.createElement("a", {
        href: constants/* appsConfig.ios.storeUrl */.K.ios.storeUrl,
        target: TARGET,
        rel: REL
    }, /*#__PURE__*/ react.createElement("img", {
        src: imgSrc(market, "appstore"),
        alt: "App Store",
        width: WIDTH,
        height: HEIGHT
    }));
};

;// CONCATENATED MODULE: ./src/areas/list-page/components/apps-banner/index.tsx





var BANNER_BG_IMG_URL = "https://cdn.pji.nu/g/lists/web/apps-dl-banner-bg.png";
var AppsBanner = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(StyledRoot, {
        bannerBackgroundUrl: BANNER_BG_IMG_URL
    }, /*#__PURE__*/ react.createElement(StyledCenteredTexts, null, /*#__PURE__*/ react.createElement(text_variants.H3Text, null, t("lists", "list.banner-title")), /*#__PURE__*/ react.createElement(text_variants.BodySmallText, null, t("lists", "list.banner-text"))), /*#__PURE__*/ react.createElement(StyledAppIconsWrapper, null, /*#__PURE__*/ react.createElement(AndroidAppDownloadButton, null), /*#__PURE__*/ react.createElement(IOSAppDownloadButton, null)));
};

// EXTERNAL MODULE: ./src/areas/list-page/components/share/index.tsx + 1 modules
var share = __webpack_require__(39371);
// EXTERNAL MODULE: ./src/areas/sidebar/constants.ts
var sidebar_constants = __webpack_require__(90081);
;// CONCATENATED MODULE: ./src/areas/list-page/utils.ts
// This is a temporary fix to set a default theme for lists with semi-private visibility
// This should be removed once user lists API supports listKey
var getTheme = function(marketCdn) {
    return {
        backgroundColor: {
            hex: "#01A1BE"
        },
        foregroundColor: {
            hex: "#FFFFFF"
        },
        url: "".concat(marketCdn, "/g/lists/themes/08-mobile.webp")
    };
};

;// CONCATENATED MODULE: ./src/areas/list-page/components/list-page/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n    margin-top: 0;\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  min-height: 800px;\n  margin-top: ",
        ";\n  ",
        ";\n\n  @supports (display: grid) {\n    display: grid;\n    grid-template-columns: 1fr;\n    column-gap: ",
        ";\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  padding: 0 0;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  padding: ",
        ";\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n    width: 100%;\n    padding: ",
        ";\n  "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    max-width: ",
        ";\n    width: 60%;\n    justify-self: center;\n\n    ",
        ";\n  "
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: none;\n  border-left: 1px solid ",
        ";\n  padding: 0 ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-size: 18px;\n  margin-bottom: 0;\n  background: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n  height: 64px;\n  margin-right: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  display: flex;\n  flex-direction: row;\n  font-size: ",
        ";\n  > *:first-child {\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = styles_taggedTemplateLiteral([
        "\n    font-weight: 700;\n    margin-top: ",
        ";\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = styles_taggedTemplateLiteral([
        ""
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = styles_taggedTemplateLiteral([
        "\n  padding: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = styles_taggedTemplateLiteral([
        "\n    margin-left: auto;\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-end;\n  gap: ",
        ";\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = styles_taggedTemplateLiteral([
        ""
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  margin: ",
        " 0 ",
        "\n    ",
        ";\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = styles_taggedTemplateLiteral([
        "\n          background-image: url(",
        ");\n        "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = styles_taggedTemplateLiteral([
        "\n          background-color: ",
        ";\n        "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = styles_taggedTemplateLiteral([
        "\n    border-radius: 24px;\n  "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: 980px;\n  height: 220px;\n  display: flex;\n  justify-content: center;\n  background-size: cover;\n  background-position: center;\n\n  ",
        "\n\n  ",
        ";\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: ",
        ";\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = styles_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  padding: ",
        ";\n  word-break: break-word;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = styles_taggedTemplateLiteral([
        "\n  text-align: center;\n  align-self: center;\n  font-weight: 700;\n  color: ",
        ";\n  white-space: normal;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: ",
        ";\n  gap: ",
        ";\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = styles_taggedTemplateLiteral([
        "\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = styles_taggedTemplateLiteral([
        "\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row-reverse;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = styles_taggedTemplateLiteral([
        "\n  line-height: 0.8;\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}






var PublicList = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PublicList",
    componentId: "sc-0-0"
})(styles_templateObject1(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* media.mediumDown */.BC.mediumDown(styles_templateObject()), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var Header = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Header",
    componentId: "sc-0-1"
})(styles_templateObject2());
var ActionBar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ActionBar",
    componentId: "sc-0-2"
})(styles_templateObject3(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var List = styled_components_browser_esm["default"].div.withConfig({
    displayName: "List",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components_browser_esm.css)(styles_templateObject5(), base/* layout.siteWidth.rem */.bK.siteWidth.rem, base/* media.mediumDown */.BC.mediumDown(styles_templateObject4(), props.$noPadding ? 0 : base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
});
var SideColumn = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SideColumn",
    componentId: "sc-0-4"
})(_templateObject6(), function(p) {
    return p.theme.lines.primary;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var Title = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Title",
    componentId: "sc-0-5"
})(_templateObject7());
var ListName = styled_components_browser_esm["default"].h1.withConfig({
    displayName: "ListName",
    componentId: "sc-0-6"
})(_templateObject8(), function(p) {
    return p.theme.bg.primary;
});
var ListIcon = styled_components_browser_esm["default"].img.withConfig({
    displayName: "ListIcon",
    componentId: "sc-0-7"
})(_templateObject9(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Info = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Info",
    componentId: "sc-0-8"
})(_templateObject10(), function(p) {
    return p.theme.text.quaternary;
}, base/* layout.fontSizes.small.desktop.rem */.bK.fontSizes.small.desktop.rem, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var User = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "User",
    componentId: "sc-0-9"
})(_templateObject11(), function(p) {
    return p.theme.text.callToActionHover;
});
var UserName = (0,styled_components_browser_esm["default"])(text_variants.H4Text).withConfig({
    displayName: "UserName",
    componentId: "sc-0-10"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject12(), props.$isPartner ? 0 : base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
});
var CreatedDate = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CreatedDate",
    componentId: "sc-0-11"
})(_templateObject13());
var Comment = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Comment",
    componentId: "sc-0-12"
})(_templateObject14(), function(p) {
    return p.theme.text.primary;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Summary = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Summary",
    componentId: "sc-0-13"
})(_templateObject15(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var SummaryPrice = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SummaryPrice",
    componentId: "sc-0-14"
})(_templateObject17(), base/* media.mediumUp */.BC.mediumUp(_templateObject16()));
var NameRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "NameRow",
    componentId: "sc-0-15"
})(_templateObject18(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Partner = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Partner",
    componentId: "sc-0-16"
})(_templateObject19());
var ItemCount = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ItemCount",
    componentId: "sc-0-17"
})(_templateObject20());
var BreadCrumbWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BreadCrumbWrapper",
    componentId: "sc-0-18"
})(_templateObject21(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ListHero = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListHero",
    componentId: "sc-0-19"
})(_templateObject25(), function(p) {
    return p.$imgUrl ? (0,styled_components_browser_esm.css)(_templateObject22(), p.$imgUrl) : (0,styled_components_browser_esm.css)(_templateObject23(), p.$backgroundColor);
}, base/* media.mediumUp */.BC.mediumUp(_templateObject24()));
var ListHeroInner = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListHeroInner",
    componentId: "sc-0-20"
})(_templateObject26(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200);
var ListHeroTextWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListHeroTextWrapper",
    componentId: "sc-0-21"
})(_templateObject27(), function(p) {
    return p.$backgroundColor;
}, base/* layout.measurements.spacing075 */.bK.measurements.spacing075);
var ListHeroText = (0,styled_components_browser_esm["default"])(text_variants.H1Text).withConfig({
    displayName: "ListHeroText",
    componentId: "sc-0-22"
})(_templateObject28(), function(p) {
    return p.$foregroundColor;
});
var ListAction = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListAction",
    componentId: "sc-0-23"
})(_templateObject29(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ListActionWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListActionWrapper",
    componentId: "sc-0-24"
})(_templateObject30());
var ListPrimaryButton = (0,styled_components_browser_esm["default"])(variants.PrimaryButton).withConfig({
    displayName: "ListPrimaryButton",
    componentId: "sc-0-25"
})(_templateObject31(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
var ListTonalButton = (0,styled_components_browser_esm["default"])(variants.TonalButton).withConfig({
    displayName: "ListTonalButton",
    componentId: "sc-0-26"
})(_templateObject32(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
var ListPopover = (0,styled_components_browser_esm["default"])(popover/* Popover */.J2).withConfig({
    displayName: "ListPopover",
    componentId: "sc-0-27"
})(_templateObject33(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ListPopoverOuter = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListPopoverOuter",
    componentId: "sc-0-28"
})(_templateObject34(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075);
var ListDescription = (0,styled_components_browser_esm["default"])(text_variants.BodyMediumText).withConfig({
    displayName: "ListDescription",
    componentId: "sc-0-29"
})(_templateObject35(), base/* layout.measurements.spacing250 */.bK.measurements.spacing250);
var ListPopoverDownloadApp = (0,styled_components_browser_esm["default"])(text_variants.TitleSmallText).withConfig({
    displayName: "ListPopoverDownloadApp",
    componentId: "sc-0-30"
})(_templateObject36(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var DownloadLink = styled_components_browser_esm["default"].a.withConfig({
    displayName: "DownloadLink",
    componentId: "sc-0-31"
})(_templateObject37(), base/* colors.lightTheme.maybeBlue700 */.O9.lightTheme.maybeBlue700);
var SummaryAndSortWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SummaryAndSortWrapper",
    componentId: "sc-0-32"
})(_templateObject38(), function(p) {
    return p.theme.lines.primary;
});
var PartnerText = (0,styled_components_browser_esm["default"])(text_variants.BodySmallText).withConfig({
    displayName: "PartnerText",
    componentId: "sc-0-33"
})(_templateObject39());
var ListsWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListsWrapper",
    componentId: "sc-0-34"
})(_templateObject40(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

;// CONCATENATED MODULE: ./src/areas/list-page/components/list-page/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



























var list_page_REL = "noreferrer noopener";
var list_page_TARGET = "_blank";
var MIN_ITEMS_TO_DISPLAY_2ND_APPS_BANNER = 6;
var ListPage = function(param) {
    var isFetching = param.isFetching, isPreviousData = param.isPreviousData, list = param.list, setDirection = param.setDirection, setLimit = param.setLimit, setSort = param.setSort, showListActions = param.showListActions, themeData = param.themeData;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var ref14 = (0,app_context/* useAppContext */.bp)(), linkTo = ref14.linkTo, market = ref14.market, t = ref14.t;
    var isMobile = (0,context/* useViewportContext */.Ak)().isMobile;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref15 = _slicedToArray((0,react.useState)(false), 2), showPopover = ref15[0], setShowPopover = ref15[1];
    var productIds = (ref = list.items) === null || ref === void 0 ? void 0 : ref.nodes.map(function(listItem) {
        if (listItem.__typename === "ListProduct" && listItem.product) {
            return {
                id: listItem.product.id
            };
        }
        return null;
    }).filter(function(x) {
        return x;
    });
    var onCreateAlert = (0,react.useCallback)(function(product) {
        dispatch((0,actions_alert/* createAlertRequest */.$b)({
            productId: product === null || product === void 0 ? void 0 : product.id
        }));
    }, [
        dispatch
    ]);
    var theme = getTheme(market.cdn);
    var ref16 = (0,use_rebranding/* useRebranding */.y)(), rebrand = ref16.enabled;
    var _hex, _url, _hex1, _hex2;
    return /*#__PURE__*/ react.createElement(PublicList, null, /*#__PURE__*/ react.createElement(ListsWrapper, null, /*#__PURE__*/ react.createElement(List, null, /*#__PURE__*/ react.createElement(Header, null, /*#__PURE__*/ react.createElement(Title, null, /*#__PURE__*/ react.createElement(Info, null, ((ref1 = list.user) === null || ref1 === void 0 ? void 0 : ref1.id) ? /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: linkTo("user", {
            id: list.user.id
        })
    }, /*#__PURE__*/ react.createElement(user_avatar/* UserAvatar */.Y, {
        displayName: list.user.displayName,
        avatar: (ref2 = list.user.schibstedProfile) === null || ref2 === void 0 ? void 0 : ref2.avatar,
        size: 40,
        rebrandDesign: true,
        isExpert: list.user.isExpert
    })) : null, /*#__PURE__*/ react.createElement(Partner, null, ((ref3 = list.user) === null || ref3 === void 0 ? void 0 : ref3.displayName) ? /*#__PURE__*/ react.createElement(NameRow, null, /*#__PURE__*/ react.createElement(User, {
        to: linkTo("user", {
            id: list.user.id
        })
    }, /*#__PURE__*/ react.createElement(UserName, {
        $isPartner: Boolean(themeData === null || themeData === void 0 ? void 0 : (ref4 = themeData.getListById) === null || ref4 === void 0 ? void 0 : ref4.partnerList)
    }, list.user.displayName)), rebrand && list.user.isExpert && /*#__PURE__*/ react.createElement(expert_user_label/* ExpertUserLabel */.d, null)) : null, (themeData === null || themeData === void 0 ? void 0 : (ref5 = themeData.getListById) === null || ref5 === void 0 ? void 0 : ref5.partnerList) && /*#__PURE__*/ react.createElement(PartnerText, null, t("lists", "list.partner")))), /*#__PURE__*/ react.createElement(ActionBar, null, productIds && productIds.length > 0 ? /*#__PURE__*/ react.createElement(compare/* default */.Z, {
        products: productIds,
        buttonText: isMobile ? "" : t("product", "product-compare.compare")
    }) : null, showListActions && /*#__PURE__*/ react.createElement(share/* default */.Z, {
        id: list.id,
        name: list.name,
        pathName: list.pathName,
        owner: (ref6 = list.user) === null || ref6 === void 0 ? void 0 : ref6.displayName,
        buttonText: !isMobile
    }))))), /*#__PURE__*/ react.createElement(List, {
        $noPadding: isMobile
    }, /*#__PURE__*/ react.createElement(Header, null, /*#__PURE__*/ react.createElement(ListHero, {
        $backgroundColor: (_hex = themeData === null || themeData === void 0 ? void 0 : (ref7 = themeData.getListById) === null || ref7 === void 0 ? void 0 : ref7.theme.backgroundColor.hex) !== null && _hex !== void 0 ? _hex : theme.backgroundColor.hex,
        $imgUrl: (_url = themeData === null || themeData === void 0 ? void 0 : (ref8 = themeData.getListById) === null || ref8 === void 0 ? void 0 : ref8.theme.url) !== null && _url !== void 0 ? _url : theme.url,
        $noMarginOnMobile: isMobile
    }, /*#__PURE__*/ react.createElement(ListHeroInner, null, /*#__PURE__*/ react.createElement(ListHeroTextWrapper, {
        $backgroundColor: (_hex1 = themeData === null || themeData === void 0 ? void 0 : (ref9 = themeData.getListById) === null || ref9 === void 0 ? void 0 : ref9.theme.backgroundColor.hex) !== null && _hex1 !== void 0 ? _hex1 : theme.backgroundColor.hex
    }, /*#__PURE__*/ react.createElement(ListHeroText, {
        $foregroundColor: (_hex2 = themeData === null || themeData === void 0 ? void 0 : (ref10 = themeData.getListById) === null || ref10 === void 0 ? void 0 : ref10.theme.foregroundColor.hex) !== null && _hex2 !== void 0 ? _hex2 : theme.foregroundColor.hex
    }, list.name)))))), /*#__PURE__*/ react.createElement(List, null, showListActions && /*#__PURE__*/ react.createElement(ListActionWrapper, null, /*#__PURE__*/ react.createElement(ListPopover, {
        id: "follow-copy-action",
        visible: showPopover,
        width: 300,
        horizontalAlign: popover/* Alignment.Center */.v2.Center,
        verticalAlign: popover/* Alignment.StartOutside */.v2.StartOutside,
        onClose: function() {
            return setTimeout(function() {
                return setShowPopover(false);
            });
        }
    }, /*#__PURE__*/ react.createElement(ListPopoverOuter, null, /*#__PURE__*/ react.createElement(text_variants.BodySmallText, null, t("lists", "shared.action-popover-message")), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, /*#__PURE__*/ react.createElement(DownloadLink, {
        href: constants/* appsConfig.android.storeUrl */.K.android.storeUrl,
        target: list_page_TARGET,
        rel: list_page_REL
    }, t("lists", "title.download-android-app")))), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, /*#__PURE__*/ react.createElement(DownloadLink, {
        href: constants/* appsConfig.ios.storeUrl */.K.ios.storeUrl,
        target: list_page_TARGET,
        rel: list_page_REL
    }, t("lists", "title.download-ios-app"))))))), /*#__PURE__*/ react.createElement(ListAction, null, /*#__PURE__*/ react.createElement(ListPrimaryButton, {
        radius: variants.ButtonRadius.ROUNDED2,
        onClick: function() {
            return setShowPopover(true);
        },
        opacity: variants.ButtonOpacity._500
    }, /*#__PURE__*/ react.createElement(variants.ButtonIcon, null, /*#__PURE__*/ react.createElement(plus/* IconPlus */.S, null)), /*#__PURE__*/ react.createElement(variants.ButtonText, null, t("common", "title.follow"))), /*#__PURE__*/ react.createElement(ListTonalButton, {
        radius: variants.ButtonRadius.ROUNDED2,
        onClick: function() {
            return setShowPopover(true);
        },
        opacity: variants.ButtonOpacity._500
    }, /*#__PURE__*/ react.createElement(variants.ButtonIcon, null, /*#__PURE__*/ react.createElement(copy/* IconCopy */.v, null)), /*#__PURE__*/ react.createElement(variants.ButtonText, null, t("common", "title.copy"))))), (themeData === null || themeData === void 0 ? void 0 : (ref11 = themeData.getListById) === null || ref11 === void 0 ? void 0 : ref11.description) && /*#__PURE__*/ react.createElement(ListDescription, null, themeData === null || themeData === void 0 ? void 0 : (ref12 = themeData.getListById) === null || ref12 === void 0 ? void 0 : ref12.description), /*#__PURE__*/ react.createElement(AppsBanner, null), list.items && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(SummaryAndSortWrapper, null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(sort_button/* default */.Z, {
        sort: _objectSpreadProps(_objectSpread({}, (ref13 = list.items) === null || ref13 === void 0 ? void 0 : ref13.pageInfo.sort), {
            available: [
                sidebar_constants/* SORT_OPTIONS.ADDED */.aP.ADDED,
                sidebar_constants/* SORT_OPTIONS.NAME */.aP.NAME,
                sidebar_constants/* SORT_OPTIONS.PRICE_ASC */.aP.PRICE_ASC,
                sidebar_constants/* SORT_OPTIONS.PRICE_DESC */.aP.PRICE_DESC,
                sidebar_constants/* SORT_OPTIONS.CATEGORY */.aP.CATEGORY
            ]
        }),
        onSelect: function(sortOption) {
            var ref = _slicedToArray(sortOption.value.split(":"), 2), selectedSort = ref[0], selectedDirection = ref[1];
            setSort(selectedSort);
            setDirection(selectedDirection);
        },
        showBorder: true
    })), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(Summary, null, /*#__PURE__*/ react.createElement(SummaryPrice, null, /*#__PURE__*/ react.createElement(text_variants.H3Text, null, /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
        price: list.priceSummary
    })), /*#__PURE__*/ react.createElement(text_variants.CaptionText, null, t("lists", "list.n-items", {
        n: list.itemsCount
    })))))), list.items.nodes.map(function(item) {
        return /*#__PURE__*/ react.createElement(list_item/* ListItem */.H, {
            item: item,
            key: item.id,
            createAlert: onCreateAlert
        });
    }), list.items.pageInfo.hasNext ? /*#__PURE__*/ react.createElement(components_button/* Button */.z, {
        variant: "text",
        color: "primary",
        onClick: function() {
            return setLimit(function(limit) {
                return limit + constants/* LIMIT */.V;
            });
        },
        icon: isPreviousData && isFetching ? /*#__PURE__*/ react.createElement(spinner/* Spinner */.$, {
            isActive: true,
            position: "none",
            size: 16
        }) : /*#__PURE__*/ react.createElement(chevron_down/* IconChevronDown */.C, null),
        iconPosition: "bottom"
    }, t("common", "button.show-more")) : null), isMobile && list.itemsCount > 0 && /*#__PURE__*/ react.createElement(Summary, null, /*#__PURE__*/ react.createElement(SummaryPrice, null, t("lists", "list.price-sum", {
        sum: /*#__PURE__*/ react.createElement("strong", null, /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
            price: list.priceSummary
        }))
    }))), list.itemsCount >= MIN_ITEMS_TO_DISPLAY_2ND_APPS_BANNER && /*#__PURE__*/ react.createElement(AppsBanner, null))), /*#__PURE__*/ react.createElement(SideColumn, null));
};


/***/ }),

/***/ 39371:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ components_share)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(99816);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/clickable/index.js
var clickable = __webpack_require__(42007);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/share/index.js
var share = __webpack_require__(4436);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/link/index.js
var icon_link = __webpack_require__(30577);
// EXTERNAL MODULE: ./src/components/modal-v2/modal.tsx
var modal = __webpack_require__(72291);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/modal/index.js
var ui_modal = __webpack_require__(51676);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(50238);
// EXTERNAL MODULE: ./src/areas/sidebar/views/list/actions/index.ts
var actions = __webpack_require__(59209);
// EXTERNAL MODULE: ./src/components/toast-container/actions/index.ts
var toast_container_actions = __webpack_require__(40744);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/lists.js
var lists = __webpack_require__(96805);
// EXTERNAL MODULE: ./src/areas/list-page/components/visibility-picker/index.tsx + 1 modules
var visibility_picker = __webpack_require__(31963);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/components/inputs/index.ts + 10 modules
var inputs = __webpack_require__(32741);
;// CONCATENATED MODULE: ./src/areas/list-page/components/share/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    padding: ",
        ";\n    flex-grow: 0;\n    color: ",
        ";\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  grid-area: 1 / 1 / 2 / 3;\n\n  input {\n    border-radius: 3px;\n    cursor: text;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: auto auto;\n  gap: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var ShareButton = (0,styled_components_browser_esm["default"])(variants.TextButton).withConfig({
    displayName: "ShareButton",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075, function(p) {
    return p.theme.text.primary;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var Share = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Share",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Input = (0,styled_components_browser_esm["default"])(inputs/* TextInput */.oi).withConfig({
    displayName: "Input",
    componentId: "sc-0-2"
})(_templateObject2());
var Clipboard = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Clipboard",
    componentId: "sc-0-3"
})(_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/list-page/components/share/index.tsx
















var share_Share = function(param) {
    var id = param.id, uid = param.uid, name = param.name, pathName = param.pathName, onClick = param.onClick, visibility = param.visibility, buttonText = param.buttonText, listType = param.listType;
    var dispatch = (0,es/* useDispatch */.I0)();
    var openShareId = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.list.openShareId;
    });
    var ref = (0,app_context/* useAppContext */.bp)(), linkTo = ref.linkTo, market = ref.market, t = ref.t;
    var isMobile = (0,context/* useViewportContext */.Ak)().isMobile;
    var reactUid = (0,react.useId)();
    var modalId = uid || reactUid;
    var isOpen = modalId === openShareId;
    var host =  true ? window.location.host : 0;
    var listUrl = "https://".concat(host).concat(linkTo("list", {
        pathName: pathName
    }));
    var toggleShare = (0,react.useCallback)(function() {
        dispatch((0,actions/* toggleListShare */.e)(modalId));
    }, [
        dispatch,
        modalId
    ]);
    var handleToggle = (0,react.useCallback)(function() {
        if ( true && isMobile && navigator.share) {
            // NOTE: The Web Share API spec is in draft, and does not currently work properly.
            // When providing a title and/or text, this will be included in the "Copy" option
            // resulting in broken links. These should be added back in the future when the
            // API is more stable.
            // const text = owner ? t('meta', 'list.title', { name, owner }) : name;
            var data = {
                // text,
                url: "".concat(listUrl)
            };
            navigator.share(data).catch(function(e) {
                // Fallback to normal share UI if Web Share API failed
                // code 20 means share menu was manually closed.
                if (e.code !== 20) {
                    toggleShare();
                }
            });
        } else if (onClick) {
            onClick();
        } else {
            toggleShare();
        }
    }, [
        onClick,
        listUrl,
        isMobile,
        toggleShare
    ]);
    var copyToClipboard = (0,react.useCallback)(function() {
        if ( false || !listUrl) return;
        navigator.clipboard.writeText(listUrl).then(function() {
            if (isOpen) toggleShare();
            dispatch((0,toast_container_actions/* promptToast */.Lf)("success", t("lists", "confirm.copied")));
        });
    }, [
        listUrl,
        dispatch,
        t,
        isOpen,
        toggleShare
    ]);
    var handleSelect = (0,react.useCallback)(function(e) {
        e.target.select();
    }, []);
    var handleCloseShare = (0,react.useCallback)(function() {
        if (isOpen) toggleShare();
    }, [
        toggleShare,
        isOpen
    ]);
    var handleVisibilityChange = function(newVisibility) {
        return dispatch((0,lists/* editListRequest */.xb)(Number(id), name, newVisibility));
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(ShareButton, {
        container: clickable.Clickable,
        onClick: handleToggle
    }, /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, null, /*#__PURE__*/ react.createElement(share/* IconShare */.F, null)), buttonText && /*#__PURE__*/ react.createElement(ui_button.ButtonText, null, t("lists", "button.share"))), isOpen && /*#__PURE__*/ react.createElement(modal["default"], {
        isOpen: true,
        size: ui_modal/* ModalSizeEnum.SMALL */.E$.SMALL,
        onRequestClose: handleCloseShare
    }, /*#__PURE__*/ react.createElement(ui_modal/* ModalBody */.fe, null, /*#__PURE__*/ react.createElement("h3", null, t("lists", "share.title")), /*#__PURE__*/ react.createElement(Share, null, visibility && /*#__PURE__*/ react.createElement(visibility_picker/* default */.Z, {
        visibility: visibility,
        onChange: function(newVisibility) {
            return handleVisibilityChange(newVisibility);
        },
        listType: listType
    }), /*#__PURE__*/ react.createElement(Clipboard, null, listUrl && /*#__PURE__*/ react.createElement(Input, {
        name: "listName",
        type: "text",
        readOnly: true,
        value: listUrl,
        onFocus: handleSelect,
        onClick: handleSelect,
        disabled: visibility === "private",
        autoFocus: true
    }), navigator.clipboard && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(variants.OutlinedButton, {
        onClick: handleCloseShare,
        fullWidth: true
    }, t("common", "button.cancel")), /*#__PURE__*/ react.createElement(variants.PrimaryButton, {
        onClick: copyToClipboard,
        disabled: visibility === "private",
        fullWidth: true,
        style: {
            whiteSpace: "nowrap"
        }
    }, /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, null, /*#__PURE__*/ react.createElement(icon_link/* IconLink */.J, null)), /*#__PURE__*/ react.createElement(ui_button.ButtonText, null, t("lists", "button.copy-link")))))))));
};
/* harmony default export */ var components_share = (share_Share);


/***/ }),

/***/ 31963:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ visibility_picker)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/dropdown-new/index.ts + 2 modules
var dropdown_new = __webpack_require__(13961);
// EXTERNAL MODULE: ./src/components/spinner/index.ts + 2 modules
var spinner = __webpack_require__(61061);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(95088);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/list-page/components/visibility-picker/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: min-content 1fr;\n  grid-template-rows: auto auto;\n  align-items: center;\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  grid-area: 2 / 1 / 2 / 3;\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var VisibilityPicker = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VisibilityPicker",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var Description = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Description",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall, function(p) {
    return p.theme.text.secondary;
});

;// CONCATENATED MODULE: ./src/areas/list-page/components/visibility-picker/index.tsx







var ListType;
(function(ListType) {
    ListType["wishList"] = "wish_list";
    ListType["shoppingList"] = "shopping_list";
})(ListType || (ListType = {}));
var visibility_picker_VisibilityPicker = function(param) {
    var visibility = param.visibility, onChange = param.onChange, listType = param.listType;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var pending = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.sidebar.pending;
    });
    var visibilityOptions = {
        private: {
            name: t("lists", "list.visibility-private"),
            description: t("lists", "list.visibility-private-description")
        },
        semiPrivate: {
            name: t("lists", "list.visibility-semi-private"),
            description: t("lists", "list.visibility-semi-private-description")
        },
        public: {
            name: t("lists", "list.visibility-public"),
            description: t("lists", "list.visibility-public-description")
        }
    };
    return /*#__PURE__*/ react.createElement(VisibilityPicker, null, /*#__PURE__*/ react.createElement("span", null, t("lists", "list.change-visibility")), /*#__PURE__*/ react.createElement(dropdown_new/* DropdownNew */.cw, {
        variant: "secondary",
        showArrow: !pending,
        toggleElement: /*#__PURE__*/ react.createElement(components_button/* Button */.z, {
            variant: "text",
            color: "primary",
            iconPosition: "right",
            icon: pending ? /*#__PURE__*/ react.createElement(spinner/* Spinner */.$, {
                isActive: pending,
                position: "none",
                size: 16
            }) : null
        }, visibilityOptions[visibility].name)
    }, Object.keys(visibilityOptions).filter(function(option) {
        // If the listType is wish_list, only show the 'private' option. Since we don't want the user to change the visibility of their wish list.
        if (listType === ListType.wishList) {
            return option === "private";
        }
        return option !== visibility;
    }).map(function(option) {
        return /*#__PURE__*/ react.createElement(dropdown_new/* ListItem */.HC, {
            key: option,
            onClick: function() {
                return onChange(option);
            }
        }, visibilityOptions[option].name);
    })), /*#__PURE__*/ react.createElement(Description, null, visibilityOptions[visibility].description));
};
/* harmony default export */ var visibility_picker = (visibility_picker_VisibilityPicker);


/***/ }),

/***/ 52333:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ my_list)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(12321);
// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(62619);
// EXTERNAL MODULE: ./src/areas/list-page/components/list-page/index.tsx + 5 modules
var list_page = __webpack_require__(93984);
// EXTERNAL MODULE: ./src/areas/sidebar/list-query.graphql
var list_query_graphql = __webpack_require__(20907);
var list_query_graphql_default = /*#__PURE__*/__webpack_require__.n(list_query_graphql);
// EXTERNAL MODULE: ./src/hooks/use-page-query.ts
var use_page_query = __webpack_require__(48458);
;// CONCATENATED MODULE: ./src/areas/list-page/queries/useUserList.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


function useUserList(variables) {
    return (0,use_page_query/* usePageQuery */.v)({
        routeName: "userList",
        query: (list_query_graphql_default()),
        variables: _objectSpreadProps(_objectSpread({}, variables), {
            offset: 0
        })
    });
}

// EXTERNAL MODULE: ./src/areas/list-page/queries/useGetListByUserId.ts
var useGetListByUserId = __webpack_require__(85170);
// EXTERNAL MODULE: ./src/areas/list-page/constants.ts
var constants = __webpack_require__(39563);
;// CONCATENATED MODULE: ./src/areas/list-page/my-list/my-list.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








var MyList = function() {
    var id = (0,react_router_dom/* useParams */.UO)().id;
    var ref = _slicedToArray((0,react.useState)(), 2), sort = ref[0], setSort = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(), 2), direction = ref1[0], setDirection = ref1[1];
    var ref2 = _slicedToArray((0,react.useState)(constants/* LIMIT */.V), 2), limit = ref2[0], setLimit = ref2[1];
    var ref3 = useUserList({
        id: id,
        limit: limit,
        sort: sort,
        direction: direction
    }), data = ref3.data, isLoading = ref3.isLoading, isPreviousData = ref3.isPreviousData, isFetching = ref3.isFetching;
    var ref4 = (0,useGetListByUserId/* useGetListByUserId */.k)({
        listId: Number(id)
    }), themeData = ref4.data, isThemeLoading = ref4.isLoading;
    var list = data === null || data === void 0 ? void 0 : data.me.list;
    if (isLoading || isThemeLoading) {
        return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, null, /*#__PURE__*/ react.createElement(loader/* default */.Z, null));
    }
    if (!list) return null;
    return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, null, /*#__PURE__*/ react.createElement(list_page/* ListPage */.q, {
        isPreviousData: isPreviousData,
        isFetching: isFetching,
        list: list,
        setDirection: setDirection,
        setLimit: setLimit,
        setSort: setSort,
        themeData: themeData
    }));
};
/* harmony default export */ var my_list = (MyList);


/***/ }),

/***/ 88990:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ public_list)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(12321);
// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(62619);
// EXTERNAL MODULE: ./src/areas/list-page/components/list-page/index.tsx + 5 modules
var list_page = __webpack_require__(93984);
// EXTERNAL MODULE: ./src/areas/list-page/queries/public-list-query.graphql
var public_list_query_graphql = __webpack_require__(95307);
var public_list_query_graphql_default = /*#__PURE__*/__webpack_require__.n(public_list_query_graphql);
// EXTERNAL MODULE: ./src/hooks/use-page-query.ts
var use_page_query = __webpack_require__(48458);
;// CONCATENATED MODULE: ./src/areas/list-page/queries/usePublicList.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


function usePublicList(variables) {
    return (0,use_page_query/* usePageQuery */.v)({
        routeName: "publicList",
        query: (public_list_query_graphql_default()),
        variables: _objectSpreadProps(_objectSpread({}, variables), {
            offset: 0
        })
    });
}

// EXTERNAL MODULE: ./src/areas/list-page/queries/useGetListByUserId.ts
var useGetListByUserId = __webpack_require__(85170);
// EXTERNAL MODULE: ./src/areas/list-page/constants.ts
var constants = __webpack_require__(39563);
;// CONCATENATED MODULE: ./src/areas/list-page/public-list/public-list.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








var PublicList = function() {
    var id = (0,react_router_dom/* useParams */.UO)().id;
    var ref = _slicedToArray((0,react.useState)(), 2), sort = ref[0], setSort = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(), 2), direction = ref1[0], setDirection = ref1[1];
    var ref2 = _slicedToArray((0,react.useState)(constants/* LIMIT */.V), 2), limit = ref2[0], setLimit = ref2[1];
    var ref3 = usePublicList({
        id: Number(id),
        limit: limit,
        sort: sort,
        direction: direction
    }), data = ref3.data, isLoading = ref3.isLoading, isPreviousData = ref3.isPreviousData, isFetching = ref3.isFetching;
    var ref4 = (0,useGetListByUserId/* useGetListByUserId */.k)({
        listId: Number(id)
    }), themeData = ref4.data, isThemeLoading = ref4.isLoading;
    var list = (data !== null && data !== void 0 ? data : {}).list;
    if (isLoading || isThemeLoading) {
        return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, null, /*#__PURE__*/ react.createElement(loader/* default */.Z, null));
    }
    if (!list) return null;
    return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, null, /*#__PURE__*/ react.createElement(list_page/* ListPage */.q, {
        isPreviousData: isPreviousData,
        isFetching: isFetching,
        list: list,
        setDirection: setDirection,
        setLimit: setLimit,
        setSort: setSort,
        themeData: themeData,
        showListActions: true
    }));
};
/* harmony default export */ var public_list = (PublicList);


/***/ }),

/***/ 85170:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": () => (/* binding */ useGetListByUserId)
/* harmony export */ });
/* harmony import */ var _theme_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98571);
/* harmony import */ var _theme_graphql__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_theme_graphql__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_hooks_use_page_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48458);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


function useGetListByUserId(variables) {
    return (0,src_hooks_use_page_query__WEBPACK_IMPORTED_MODULE_1__/* .usePageQuery */ .v)({
        routeName: "getListById",
        query: (_theme_graphql__WEBPACK_IMPORTED_MODULE_0___default()),
        variables: _objectSpread({}, variables)
    });
}


/***/ }),

/***/ 15794:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);

var DragIndicatorIcon = function(param) {
    var size = param.size, title = param.title;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        style: {
            flexShrink: 0
        }
    }, title && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
        fill: "none"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M15.133 22.467c0 1.136-.93 2.066-2.066 2.066A2.073 2.073 0 0 1 11 22.467c0-1.137.93-2.067 2.067-2.067 1.136 0 2.066.93 2.066 2.067zM13.067 14.2c-1.137 0-2.067.93-2.067 2.067 0 1.136.93 2.066 2.067 2.066 1.136 0 2.066-.93 2.066-2.066 0-1.137-.93-2.067-2.066-2.067zm0-6.2C11.93 8 11 8.93 11 10.067c0 1.136.93 2.066 2.067 2.066 1.136 0 2.066-.93 2.066-2.066 0-1.137-.93-2.067-2.066-2.067zm6.2 4.133c1.136 0 2.066-.93 2.066-2.066 0-1.137-.93-2.067-2.066-2.067-1.137 0-2.067.93-2.067 2.067 0 1.136.93 2.066 2.067 2.066zm0 2.067c-1.137 0-2.067.93-2.067 2.067 0 1.136.93 2.066 2.067 2.066 1.136 0 2.066-.93 2.066-2.066 0-1.137-.93-2.067-2.066-2.067zm0 6.2c-1.137 0-2.067.93-2.067 2.067 0 1.136.93 2.066 2.067 2.066 1.136 0 2.066-.93 2.066-2.066 0-1.137-.93-2.067-2.066-2.067z",
        fill: "#D7D7D7"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
        width: size,
        height: size
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (DragIndicatorIcon);


/***/ }),

/***/ 95935:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": () => (/* binding */ ListItem)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(37702);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/areas/sidebar/components/item-row/styles.ts
var styles = __webpack_require__(31651);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/item-row/index.tsx


var ItemRow = function(param) {
    var name = param.name, type = param.type, icon = param.icon, subtitle = param.subtitle;
    var alternativeIcon = function() {
        switch(type){
            case "AlertSearch":
                return /*#__PURE__*/ react.createElement(styles/* SearchIcon */.W1, null);
            default:
                return null;
        }
    };
    return /*#__PURE__*/ react.createElement(styles/* ItemRow */.FD, null, /*#__PURE__*/ react.createElement(styles/* Icon */.JO, {
        border: type === "AlertSearch"
    }, alternativeIcon()), /*#__PURE__*/ react.createElement(styles/* Info */.kI, null, /*#__PURE__*/ react.createElement(styles/* Name */.VG, {
        truncate: type === "ListCategory",
        bold: type === "ListCategory"
    }, name), /*#__PURE__*/ react.createElement(styles/* Count */.XF, null, subtitle)));
};
/* harmony default export */ var item_row = (ItemRow);

// EXTERNAL MODULE: ./src/components/offer/price/price-label/index.tsx + 1 modules
var price_label = __webpack_require__(75695);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/list-price/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  margin: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 3px;\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: normal;\n  align-self: flex-end;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ListPrice = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListPrice",
    componentId: "sc-0-0"
})(_templateObject());
var CurrentPrice = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CurrentPrice",
    componentId: "sc-0-1"
})(_templateObject1());
var Quantity = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Quantity",
    componentId: "sc-0-2"
})(_templateObject2(), function(p) {
    return p.theme.text.quaternary;
}, base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall);

;// CONCATENATED MODULE: ./src/areas/sidebar/components/list-price/index.tsx



var list_price_ListPrice = function(param) {
    var price = param.price, quantity = param.quantity;
    if (!price) return null;
    return /*#__PURE__*/ react.createElement(ListPrice, null, /*#__PURE__*/ react.createElement(CurrentPrice, null, /*#__PURE__*/ react.createElement(price_label/* PriceLabel */.l, {
        value: price
    })), quantity !== 1 && /*#__PURE__*/ react.createElement(Quantity, null, "x", quantity));
};
/* harmony default export */ var list_price = (list_price_ListPrice);

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(65634);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/alert-price/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin: 0;\n  flex: 1;\n  justify-content: space-between;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-weight: normal;\n  color: ",
        ";\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  white-space: nowrap;\n  font-size: ",
        ";\n  font-style: italic;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-right: 5px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var AlertPrice = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AlertPrice",
    componentId: "sc-0-0"
})(styles_templateObject());
var LightText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "LightText",
    componentId: "sc-0-1"
})(styles_templateObject1(), function(p) {
    return p.theme.colors.base500;
});
var AlertTimeText = (0,styled_components_browser_esm["default"])(LightText).withConfig({
    displayName: "AlertTimeText",
    componentId: "sc-0-2"
})(styles_templateObject2(), base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall);
var PriceChange = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "PriceChange",
    componentId: "sc-0-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/areas/sidebar/components/alert-price/index.tsx






var alert_price_AlertPrice = function(param) {
    var price = param.price, latestPriceChange = param.latestPriceChange;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var rawPriceChange = latestPriceChange && latestPriceChange.amount;
    var rawPrice = price.regular;
    var hasRegularPrice = !!rawPrice;
    var priceUp = rawPriceChange && rawPriceChange > 0;
    var priceDown = rawPriceChange && rawPriceChange < 0;
    var showPriceChange = hasRegularPrice && latestPriceChange && (priceUp || priceDown);
    return /*#__PURE__*/ react.createElement(AlertPrice, null, latestPriceChange && /*#__PURE__*/ react.createElement(AlertTimeText, {
        key: "label"
    }, latestPriceChange.time), /*#__PURE__*/ react.createElement("div", null, latestPriceChange && Boolean(showPriceChange) && /*#__PURE__*/ react.createElement(PriceChange, {
        key: "price",
        color: priceUp ? variants.FontColor.DARK : variants.FontColor.NEGATIVE,
        weight: variants.FontWeight.HEAVIER,
        scale: variants.FontScale.XS
    }, /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
        asDiff: true,
        price: latestPriceChange.amount
    })), price.regular && hasRegularPrice ? /*#__PURE__*/ react.createElement(price_label/* PriceLabel */.l, {
        value: price.regular
    }) : /*#__PURE__*/ react.createElement(LightText, null, t("alerts", "list.no-price-found"))));
};
alert_price_AlertPrice.defaultProps = {
    latestPriceChange: null
};
/* harmony default export */ var alert_price = (/*#__PURE__*/(0,react.memo)(alert_price_AlertPrice));

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var button_variants = __webpack_require__(25670);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/edit-control/styles.ts
function edit_control_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function edit_control_styles_templateObject() {
    var data = edit_control_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-end;\n  flex-flow: column;\n  transition: opacity ease 0.25s;\n"
    ]);
    edit_control_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function edit_control_styles_templateObject1() {
    var data = edit_control_styles_taggedTemplateLiteral([
        "\n  width: 28px;\n  height: 28px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #000;\n"
    ]);
    edit_control_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function edit_control_styles_templateObject2() {
    var data = edit_control_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  white-space: nowrap;\n  cursor: pointer;\n  padding: ",
        ";\n  color: #000;\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    edit_control_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = edit_control_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  margin-left: ",
        ";\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = edit_control_styles_taggedTemplateLiteral([
        "\n  border-radius: 3px;\n  background: ",
        ";\n  width: 24px;\n  height: 24px;\n\n  svg {\n    width: 15px;\n    color: rgb(106, 124, 129);\n  }\n\n  &:not(:last-of-type) {\n    margin-right: 3px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var Edit = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Edit",
    componentId: "sc-0-0"
})(edit_control_styles_templateObject());
var EditButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "EditButton",
    componentId: "sc-0-1"
})(edit_control_styles_templateObject1());
var EditOption = styled_components_browser_esm["default"].button.withConfig({
    displayName: "EditOption",
    componentId: "sc-0-2"
})(edit_control_styles_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.dropdowns.secondary.hoverBackground;
});
var QuantityControls = styled_components_browser_esm["default"].div.withConfig({
    displayName: "QuantityControls",
    componentId: "sc-0-3"
})(styles_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var QuantityButton = (0,styled_components_browser_esm["default"])(button_variants.TonalButton).withConfig({
    displayName: "QuantityButton",
    componentId: "sc-0-4"
})(_templateObject4(), function(p) {
    return p.theme.bg.secondary;
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(99816);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/minus/index.js
var minus = __webpack_require__(17471);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/plus/index.js
var plus = __webpack_require__(31903);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/edit-control/quantity.tsx





var quantity_QuantityControls = function(param) {
    var item = param.item, updateQuantity = param.updateQuantity;
    var increaseQuantity = (0,react.useCallback)(function(e) {
        if (item.__typename !== "ListProduct") return;
        e.preventDefault();
        e.stopPropagation();
        updateQuantity(item.id, item.quantity + 1);
    }, [
        item,
        updateQuantity
    ]);
    var decreaseQuantity = (0,react.useCallback)(function(e) {
        if (item.__typename !== "ListProduct") return;
        e.preventDefault();
        e.stopPropagation();
        updateQuantity(item.id, item.quantity - 1);
    }, [
        item,
        updateQuantity
    ]);
    return item.__typename === "ListProduct" && item.quantity >= 0 ? /*#__PURE__*/ react.createElement(QuantityControls, null, /*#__PURE__*/ react.createElement(QuantityButton, {
        onlyIcon: true,
        disabled: item.quantity <= 0,
        onClick: decreaseQuantity
    }, /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, null, /*#__PURE__*/ react.createElement(minus/* IconMinus */.U, null))), /*#__PURE__*/ react.createElement(QuantityButton, {
        onlyIcon: true,
        onClick: increaseQuantity
    }, /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, null, /*#__PURE__*/ react.createElement(plus/* IconPlus */.S, null)))) : null;
};
/* harmony default export */ var quantity = (quantity_QuantityControls);

// EXTERNAL MODULE: ./src/components/product-image/index.tsx
var product_image = __webpack_require__(95242);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var components_rating = __webpack_require__(34990);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/product-row/styles.ts
function product_row_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_row_styles_templateObject() {
    var data = product_row_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: ",
        ";\n"
    ]);
    product_row_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_row_styles_templateObject1() {
    var data = product_row_styles_taggedTemplateLiteral([
        "\n  max-width: ",
        ";\n  margin-right: ",
        ";\n"
    ]);
    product_row_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function product_row_styles_templateObject2() {
    var data = product_row_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  overflow: hidden;\n"
    ]);
    product_row_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function product_row_styles_templateObject3() {
    var data = product_row_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n"
    ]);
    product_row_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = product_row_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n  color: ",
        ";\n  margin-right: 30px; /* Dont overlap edit button */\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = product_row_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  margin-right: 30px; /* Dont overlap edit button */\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = product_row_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: ",
        ";\n  justify-content: space-between;\n  flex-wrap: wrap;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = product_row_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = product_row_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-right: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = product_row_styles_taggedTemplateLiteral([
        "\n  margin-right: auto;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




var imageSize = "40px";
var padding = base/* layout.measurements.spacing050 */.bK.measurements.spacing050;
var ProductRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductRow",
    componentId: "sc-0-0"
})(product_row_styles_templateObject(), padding);
var ProductImage = (0,styled_components_browser_esm["default"])(product_image/* ProductImage */.q).withConfig({
    displayName: "ProductImage",
    componentId: "sc-0-1"
})(product_row_styles_templateObject1(), imageSize, padding);
var Info = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Info",
    componentId: "sc-0-2"
})(product_row_styles_templateObject2());
var EditControls = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EditControls",
    componentId: "sc-0-3"
})(product_row_styles_templateObject3(), padding, padding);
var Name = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Name",
    componentId: "sc-0-4"
})(styles_templateObject4(), function(p) {
    return p.theme.text.primary;
});
var Subtitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-5"
})(_templateObject5(), function(p) {
    return p.theme.text.secondary;
}, base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall);
var BottomRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BottomRow",
    componentId: "sc-0-6"
})(_templateObject6(), function(p) {
    return p.row ? "row" : "column";
});
var PriceRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceRow",
    componentId: "sc-0-7"
})(_templateObject7());
var Price = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Price",
    componentId: "sc-0-8"
})(_templateObject8(), function(p) {
    return !p.rating && p.type === "ListProduct" ? "auto" : 0;
});
var Rating = (0,styled_components_browser_esm["default"])(components_rating/* default */.Z).withConfig({
    displayName: "Rating",
    componentId: "sc-0-9"
})(_templateObject9());

;// CONCATENATED MODULE: ./src/areas/sidebar/components/product-row/index.tsx





var product_row_ProductRow = function(props) {
    var ref;
    var item = props.item, updateQuantity = props.updateQuantity;
    var rating = item.product && (((ref = item.product.aggregatedRating) === null || ref === void 0 ? void 0 : ref.score) || item.product.userReviewSummary.rating);
    var renderPrice = function() {
        switch(item.__typename){
            case "AlertProduct":
                return /*#__PURE__*/ react.createElement(alert_price, {
                    price: item.product.priceSummary,
                    latestPriceChange: item.product.latestPriceChange
                });
            case "ListProduct":
                return (item.product.priceSummary.regular || item.product.priceSummary.alternative) && /*#__PURE__*/ react.createElement(list_price, {
                    price: item.product.priceSummary.regular || item.product.priceSummary.alternative,
                    quantity: item.quantity
                });
            default:
                return null;
        }
    };
    return /*#__PURE__*/ react.createElement(ProductRow, null, item.product.media.first && /*#__PURE__*/ react.createElement(ProductImage, {
        name: item.product.name,
        src: item.product.media.first
    }), /*#__PURE__*/ react.createElement(Info, null, /*#__PURE__*/ react.createElement(Name, null, item.product.name), item.product.category && /*#__PURE__*/ react.createElement(Subtitle, null, item.product.category.name), /*#__PURE__*/ react.createElement(BottomRow, {
        row: item.__typename === "ListProduct"
    }, rating ? /*#__PURE__*/ react.createElement(Rating, {
        hide: rating === null,
        rate: rating,
        showRate: true,
        size: "small",
        singleStar: item.__typename === "ListProduct"
    }) : null, /*#__PURE__*/ react.createElement(PriceRow, null, /*#__PURE__*/ react.createElement(Price, {
        type: item.__typename,
        rating: Boolean(rating)
    }, renderPrice()), updateQuantity && /*#__PURE__*/ react.createElement(quantity, {
        item: item,
        updateQuantity: updateQuantity
    })))));
};
product_row_ProductRow.defaultProps = {
    canEdit: false
};
/* harmony default export */ var product_row = (product_row_ProductRow);

// EXTERNAL MODULE: ./src/components/dropdown-new/index.ts + 2 modules
var dropdown_new = __webpack_require__(13961);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/menu-kebab/index.js
var menu_kebab = __webpack_require__(77356);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/edit-control/index.tsx





var Options;
(function(Options) {
    Options["LIST_REMOVE"] = "LIST_REMOVE";
    Options["CREATE_ALERT"] = "CREATE_ALERT";
    Options["LIST_EDIT"] = "LIST_EDIT";
    Options["LIST_COPY"] = "LIST_COPY";
})(Options || (Options = {}));
var EditControl = function(param) {
    var item = param.item, createAlert = param.createAlert, onDelete = param.onDelete, onEdit = param.onEdit, canEdit = param.canEdit, onCopy = param.onCopy, isPublicProfile = param.isPublicProfile;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var options = [
        {
            name: t("alerts", "list.remove"),
            value: Options.LIST_REMOVE
        },
        {
            name: t("product", "alert.create-button"),
            value: Options.CREATE_ALERT
        },
        {
            name: t("common", "button.edit"),
            value: Options.LIST_EDIT
        },
        {
            name: t("lists", "button.copy-list"),
            value: Options.LIST_COPY
        }
    ];
    var deleteItem = (0,react.useCallback)(function() {
        if (!onDelete) {
            return;
        }
        switch(item.__typename){
            case "AlertProduct":
                onDelete(item.id, item.product ? item.product.id : undefined);
                return;
            case "ListProduct":
                onDelete(item.id, item.product ? item.product.id : undefined);
                return;
            case "ListSearch":
                onDelete(item.id, undefined);
                return;
            case "AlertSearch":
                onDelete(item.id, undefined);
                return;
            default:
                onDelete(item.id, undefined);
        }
    }, [
        item,
        onDelete
    ]);
    return /*#__PURE__*/ react.createElement(Edit, null, /*#__PURE__*/ react.createElement(dropdown_new/* DropdownNew */.cw, {
        variant: "secondary",
        showArrow: false,
        toggleElement: /*#__PURE__*/ react.createElement(EditButton, null, /*#__PURE__*/ react.createElement(menu_kebab/* IconMenuKebab */.Q, null)),
        grow: "left"
    }, options.filter(function(x) {
        return x;
    }).map(function(option) {
        switch(option.value){
            case Options.LIST_REMOVE:
                {
                    if (onDelete) {
                        return /*#__PURE__*/ react.createElement(EditOption, {
                            key: option.value,
                            type: "button",
                            onClick: deleteItem
                        }, option.name);
                    }
                    break;
                }
            case Options.LIST_EDIT:
                {
                    if ((item.__typename === "ListProduct" || item.__typename === "ListSearch" || item.__typename === "AlertProduct") && onEdit && canEdit) {
                        return /*#__PURE__*/ react.createElement(EditOption, {
                            key: option.value,
                            type: "button",
                            onClick: function() {
                                onEdit(item);
                            }
                        }, option.name);
                    }
                    break;
                }
            case Options.CREATE_ALERT:
                {
                    if (item.__typename === "ListProduct" && createAlert) {
                        return /*#__PURE__*/ react.createElement(EditOption, {
                            key: option.value,
                            type: "button",
                            onClick: function() {
                                createAlert(item.product);
                            }
                        }, option.name);
                    }
                    break;
                }
            case Options.LIST_COPY:
                {
                    if (item.__typename === "ListCategory" && isPublicProfile && onCopy) {
                        return /*#__PURE__*/ react.createElement(EditOption, {
                            key: option.value,
                            type: "button",
                            onClick: function() {
                                return onCopy(item.id);
                            }
                        }, option.name);
                    }
                    break;
                }
            default:
                return null;
        }
        return null;
    })));
};
EditControl.defaultProps = {
    canEdit: false
};
/* harmony default export */ var edit_control = (EditControl);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./src/areas/reviews/components/prompt/index.js
var components_prompt = __webpack_require__(32311);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/clickable/index.js
var clickable = __webpack_require__(42007);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/my-products-row/styles.tsx
function my_products_row_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function my_products_row_styles_templateObject() {
    var data = my_products_row_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 0 0 auto;\n  width: 40px;\n  height: 40px;\n  margin-right: 10px;\n  background: ",
        ";\n  border-radius: ",
        ";\n\n  .pj-ui-product-image {\n    display: block;\n    max-width: 40px;\n    max-height: 40px;\n    width: auto;\n    height: auto;\n  }\n"
    ]);
    my_products_row_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function my_products_row_styles_templateObject1() {
    var data = my_products_row_styles_taggedTemplateLiteral([
        "\n  margin-right: 30px; /* Dont overlap edit button */\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    my_products_row_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function my_products_row_styles_templateObject2() {
    var data = my_products_row_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  margin-right: 30px; /* Dont overlap edit button */\n"
    ]);
    my_products_row_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function my_products_row_styles_templateObject3() {
    var data = my_products_row_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  row-gap: ",
        ";\n  margin-bottom: ",
        ";\n  width: 100%;\n  overflow: hidden;\n"
    ]);
    my_products_row_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function my_products_row_styles_templateObject4() {
    var data = my_products_row_styles_taggedTemplateLiteral([
        "\n  border-bottom: 1px solid ",
        ";\n  padding: ",
        ";\n  display: flex;\n  flex-direction: row;\n"
    ]);
    my_products_row_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = my_products_row_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = my_products_row_styles_taggedTemplateLiteral([
        "\n  && {\n    margin-left: ",
        ";\n    font-size: 12px;\n    font-weight: 600;\n    transition: color 150ms ease;\n    color: ",
        ";\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = my_products_row_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




var ProductImageLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "ProductImageLink",
    componentId: "sc-0-0"
})(my_products_row_styles_templateObject(), function(p) {
    return p.theme.colors.base200;
}, base/* layout.borderRadius */.bK.borderRadius);
var ProductLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "ProductLink",
    componentId: "sc-0-1"
})(my_products_row_styles_templateObject1(), function(p) {
    return p.theme.text.callToActionHover;
});
var styles_Subtitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-2"
})(my_products_row_styles_templateObject2(), function(p) {
    return p.theme.text.secondary;
}, base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall);
var ProductInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductInfo",
    componentId: "sc-0-3"
})(my_products_row_styles_templateObject3(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var MyProductsRowWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MyProductsRowWrapper",
    componentId: "sc-0-4"
})(my_products_row_styles_templateObject4(), function(p) {
    return p.theme.colors.base200;
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var RatingWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RatingWrapper",
    componentId: "sc-0-5"
})(styles_templateObject5());
var CreateReviewButton = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "CreateReviewButton",
    componentId: "sc-0-6"
})(styles_templateObject6(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var styles_PriceRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceRow",
    componentId: "sc-0-7"
})(styles_templateObject7());

;// CONCATENATED MODULE: ./src/areas/sidebar/components/my-products-row/my-products-row.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var reviewedProductsSelector = function(state) {
    return state.areas.account.me.reviewedProducts;
};
var MyProductsRow = /*#__PURE__*/ (0,react.memo)(function(param) {
    var item = param.item, updateQuantity = param.updateQuantity;
    var ref;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var reviewedProducts = (0,es/* useSelector */.v9)(reviewedProductsSelector);
    var rating = (ref = reviewedProducts === null || reviewedProducts === void 0 ? void 0 : reviewedProducts.find(function(review) {
        var ref;
        return review.productId === ((ref = item.product) === null || ref === void 0 ? void 0 : ref.id);
    })) === null || ref === void 0 ? void 0 : ref.rating;
    var product = item.product;
    var _pathName, ref1;
    return /*#__PURE__*/ react.createElement(MyProductsRowWrapper, null, (product === null || product === void 0 ? void 0 : product.media.first) && /*#__PURE__*/ react.createElement(ProductImageLink, {
        to: (_pathName = product.pathName) !== null && _pathName !== void 0 ? _pathName : ""
    }, /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
        name: product.name,
        src: product.media.first
    })), /*#__PURE__*/ react.createElement(ProductInfo, null, /*#__PURE__*/ react.createElement(ProductLink, {
        to: (ref1 = product === null || product === void 0 ? void 0 : product.pathName) !== null && ref1 !== void 0 ? ref1 : ""
    }, product === null || product === void 0 ? void 0 : product.name), (product === null || product === void 0 ? void 0 : product.category) && /*#__PURE__*/ react.createElement(styles_Subtitle, null, product === null || product === void 0 ? void 0 : product.category.name), /*#__PURE__*/ react.createElement(RatingWrapper, null, /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        rate: rating,
        size: "small"
    }), !rating && product && /*#__PURE__*/ react.createElement(components_prompt/* default */.Z, {
        belongsTo: _objectSpreadProps(_objectSpread({}, product), {
            type: "product"
        }),
        control: /*#__PURE__*/ react.createElement(clickable.Clickable, null, /*#__PURE__*/ react.createElement(CreateReviewButton, null, t("reviews", "button.write-review")))
    })), /*#__PURE__*/ react.createElement(styles_PriceRow, null, ((product === null || product === void 0 ? void 0 : product.priceSummary.regular) || (product === null || product === void 0 ? void 0 : product.priceSummary.alternative)) && /*#__PURE__*/ react.createElement(list_price, {
        price: product.priceSummary.regular || product.priceSummary.alternative,
        quantity: item === null || item === void 0 ? void 0 : item.quantity
    }), updateQuantity && /*#__PURE__*/ react.createElement(quantity, {
        item: item,
        updateQuantity: updateQuantity
    }))));
});


// EXTERNAL MODULE: ./src/areas/sidebar/components/item-list/styles.ts
var item_list_styles = __webpack_require__(24279);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/item-list/list-item.tsx









var withLink = function(to, component) {
    return to ? /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: to
    }, component) : component;
};
var ListItem = function(props) {
    var _draggable = props.draggable, draggable = _draggable === void 0 ? false : _draggable, item = props.item, deleted = props.deleted, onClick = props.onClick, createAlert = props.createAlert, onEdit = props.onEdit, onDelete = props.onDelete, onCopy = props.onCopy, updateQuantity = props.updateQuantity, hasDragHandle = props.hasDragHandle, isMyProducts = props.isMyProducts, isPublicProfile = props.isPublicProfile;
    var canEdit = item.__typename !== "AlertSearch";
    var editControl = (0,react.useRef)(null);
    var showEditControl = onEdit || onDelete || createAlert || onCopy;
    var editControlElement = showEditControl ? /*#__PURE__*/ react.createElement("div", {
        ref: editControl
    }, /*#__PURE__*/ react.createElement(edit_control, {
        canEdit: canEdit,
        item: item,
        onDelete: onDelete,
        createAlert: createAlert,
        onEdit: onEdit,
        onCopy: onCopy,
        isPublicProfile: isPublicProfile
    })) : null;
    var renderListItem = function() {
        switch(item.__typename){
            case "AlertProduct":
                if (!item.product) {
                    return /*#__PURE__*/ react.createElement(item_list_styles/* NotFound */.ar, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
                        domain: "alerts"
                    }, "list.no-product-found"));
                }
                return withLink(item.product.pathName, /*#__PURE__*/ react.createElement(product_row, {
                    item: item
                }));
            case "AlertSearch":
                if (!item.search) {
                    return /*#__PURE__*/ react.createElement(item_list_styles/* NotFound */.ar, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
                        domain: "alerts"
                    }, "list.no-search-found"));
                }
                return withLink(item.search.pathName, /*#__PURE__*/ react.createElement(item_row, {
                    name: item.search.name,
                    type: item.__typename,
                    subtitle: /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
                        domain: "alerts",
                        n: item.search.productsCount
                    }, "list.n-products-found")
                }));
            case "ListProduct":
                if (isMyProducts && item.product) {
                    return /*#__PURE__*/ react.createElement(MyProductsRow, {
                        item: item,
                        updateQuantity: updateQuantity
                    });
                }
                return item.product ? withLink(item.product.pathName, /*#__PURE__*/ react.createElement(product_row, {
                    item: item,
                    updateQuantity: updateQuantity
                })) : /*#__PURE__*/ react.createElement(item_list_styles/* NotFound */.ar, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
                    domain: "alerts"
                }, "list.no-product-found"));
            case "ListSearch":
                if (!item.search) {
                    return /*#__PURE__*/ react.createElement(item_list_styles/* NotFound */.ar, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
                        domain: "alerts"
                    }, "list.no-search-found"));
                }
                return withLink(item.search.pathName, /*#__PURE__*/ react.createElement(item_row, {
                    name: item.search.name,
                    type: item.__typename,
                    subtitle: /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
                        domain: "lists",
                        n: item.search.productsCount
                    }, "list.n-products")
                }));
            case "ListCategory":
                {
                    var listItemRow = /*#__PURE__*/ react.createElement(item_row, {
                        name: item.name,
                        icon: item.icon,
                        type: item.__typename,
                        subtitle: /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
                            domain: "lists",
                            n: item.itemsCount
                        }, "list.n-items")
                    });
                    if (!isPublicProfile) {
                        return listItemRow;
                    }
                    return withLink(item.pathName, listItemRow);
                }
            default:
                return null;
        }
    };
    var handleClick = (0,react.useCallback)(function(e) {
        if (!onClick) {
            return;
        }
        // Dont nagivate to list/alert if clicking the edit button
        if (editControl.current && editControl.current.contains(e.target)) return;
        onClick(item.id);
    }, [
        item.id,
        onClick
    ]);
    var listItemStyling = [
        "ListCategory"
    ].includes(item.__typename) ? "background" : "lines";
    return /*#__PURE__*/ react.createElement(item_list_styles/* ListItem */.HC, {
        key: item.id,
        styling: listItemStyling,
        deleting: deleted ? Boolean(deleted[item.id]) : false,
        onClick: handleClick,
        draggable: draggable,
        hasDragHandle: hasDragHandle
    }, draggable && !hasDragHandle && /*#__PURE__*/ react.createElement(item_list_styles/* DragIcon */.Vn, {
        size: base/* layout.dragAndDropHandleSize.desktop.value */.bK.dragAndDropHandleSize.desktop.value
    }), /*#__PURE__*/ react.createElement(item_list_styles/* Content */.VY, null, renderListItem()), /*#__PURE__*/ react.createElement(item_list_styles/* EditControl */.$P, {
        absolutePositioned: item.__typename !== "ListCategory"
    }, editControlElement));
};


/***/ }),

/***/ 24279:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": () => (/* binding */ EditControl),
/* harmony export */   "HC": () => (/* binding */ ListItem),
/* harmony export */   "TX": () => (/* binding */ LoginButton),
/* harmony export */   "VY": () => (/* binding */ Content),
/* harmony export */   "Vn": () => (/* binding */ DragIcon),
/* harmony export */   "Zg": () => (/* binding */ ButtonsWrapper),
/* harmony export */   "ar": () => (/* binding */ NotFound),
/* harmony export */   "fr": () => (/* binding */ LoadMore),
/* harmony export */   "zF": () => (/* binding */ Unauthenticated)
/* harmony export */ });
/* unused harmony exports QuantityControls, PlaceholderListItem, CreateAccountButton, PromoText */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var _icons_drag_indicator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15794);
/* harmony import */ var _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25670);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90081);
/* harmony import */ var _item_row_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31651);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n        max-width: calc(100% - ",
        ");\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      border-radius: ",
        ";\n      background: ",
        ";\n      transition: background 150ms ease;\n\n      &:hover {\n        background: ",
        ";\n      }\n\n      ",
        " {\n        padding-left: ",
        ";\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      border-bottom: 1px solid ",
        ";\n\n      ",
        " {\n        position: absolute;\n        left: -",
        ";\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      transition:\n        max-height ",
        "ms ease,\n        opacity ",
        "ms ease;\n      opacity: 0;\n      max-height: 0;\n      overflow: hidden;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  opacity: 1;\n  position: relative;\n  margin-bottom: ",
        ";\n\n  ",
        ";\n\n  ",
        ";\n\n  ",
        ";\n\n  ",
        "\n\n  .list-dropdown {\n    .ui-dropdown--header {\n      padding: 0;\n    }\n    .ui-dropdown--list-expanded {\n      z-index: 2;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  overflow: hidden;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n\n  button {\n    width: 25px;\n    height: 25px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  height: 60px;\n  padding-left: 10px;\n  display: flex;\n  align-items: center;\n  font-style: italic;\n  color: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 65px; /* Stops content from jumping when the spinner appears */\n\n  > button {\n    display: flex;\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  pointer-events: none;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n     max-width: 267px;\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n     max-width: 100%;\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n  &:not(:last-of-type) {\n    margin-bottom: ",
        ";\n    text-align: center;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n     max-width: 267px;\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n     max-width: 100%;\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n  &:not(:last-of-type) {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  margin: ",
        " ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n      margin-right: 0;\n      position: absolute;\n      top: ",
        ";\n      right: ",
        ";\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n    padding: 0;\n  "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0 ",
        " 0\n    ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}






var padding = src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050;
var DragIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_icons_drag_indicator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    displayName: "DragIcon",
    componentId: "sc-0-0"
})(_templateObject());
var ListItem = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ListItem",
    componentId: "sc-0-1"
})(_templateObject6(), function(p) {
    return p.draggable ? 0 : src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050;
}, function(p) {
    return p.draggable && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject1(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.dragAndDropHandleSize.mobile.rem */ .bK.dragAndDropHandleSize.mobile.rem));
}, function(p) {
    return p.styling === "background" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject3(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.borderRadius */ .bK.borderRadius, p.theme.bg.secondary, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .colorUtils.shadeColor */ .$n.shadeColor(p.theme.bg.secondary, -5), _item_row_styles__WEBPACK_IMPORTED_MODULE_5__/* .ItemRow */ .FD, p.draggable && !p.hasDragHandle ? 0 : padding);
}, function(p) {
    return p.styling === "lines" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject4(), p.theme.lines.primary, DragIcon, padding);
}, function(props) {
    return props.deleting && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject5(), _constants__WEBPACK_IMPORTED_MODULE_4__/* .LIST_DELETE_TRANSITION_TIME */ .E8, _constants__WEBPACK_IMPORTED_MODULE_4__/* .LIST_DELETE_TRANSITION_TIME */ .E8);
});
ListItem.defaultProps = {
    styling: "lines"
};
var Content = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-2"
})(_templateObject7());
var QuantityControls = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "QuantityControls",
    componentId: "sc-0-3"
})(_templateObject8());
var NotFound = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "NotFound",
    componentId: "sc-0-4"
})(_templateObject9(), function(p) {
    return p.theme.text.tertiary;
});
var LoadMore = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "LoadMore",
    componentId: "sc-0-5"
})(_templateObject10());
var PlaceholderListItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(ListItem).withConfig({
    displayName: "PlaceholderListItem",
    componentId: "sc-0-6"
})(_templateObject11(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var LoginButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.PrimaryButton).withConfig({
    displayName: "LoginButton",
    componentId: "sc-0-7"
})(_templateObject14(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject12()), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallDown */ .BC.smallDown(_templateObject13()), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var CreateAccountButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.OutlinedButton).withConfig({
    displayName: "CreateAccountButton",
    componentId: "sc-0-8"
})(_templateObject17(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject15()), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallDown */ .BC.smallDown(_templateObject16()), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var PromoText = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({
    displayName: "PromoText",
    componentId: "sc-0-9"
})(_templateObject18(), function(param) {
    var theme = param.theme;
    return theme.text.tertiary;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing150 */ .bK.measurements.spacing150, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var EditControl = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "EditControl",
    componentId: "sc-0-10"
})(_templateObject20(), padding, function(p) {
    return p.absolutePositioned && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject19(), padding, padding);
});
var Unauthenticated = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Unauthenticated",
    componentId: "sc-0-11"
})(_templateObject21(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var ButtonsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ButtonsWrapper",
    componentId: "sc-0-12"
})(_templateObject23(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallDown */ .BC.smallDown(_templateObject22()));


/***/ }),

/***/ 31651:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FD": () => (/* binding */ ItemRow),
/* harmony export */   "JO": () => (/* binding */ Icon),
/* harmony export */   "VG": () => (/* binding */ Name),
/* harmony export */   "W1": () => (/* binding */ SearchIcon),
/* harmony export */   "XF": () => (/* binding */ Count),
/* harmony export */   "kI": () => (/* binding */ Info)
/* harmony export */ });
/* unused harmony exports Image, PlaceholderInfo, MoreMenu, PlaceHolderLineOfText, PlaceHolderPriceChange, CreateListIcon */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_ui_icon_magnifier__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83830);
/* harmony import */ var _prisjakt_ui_icon_heart_outlined__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72183);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: 100%;\n  flex-direction: column;\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: ",
        ";\n  text-align: left;\n  width: 100%;\n  cursor: pointer;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n  background: ",
        ";\n  padding: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 40px;\n  max-height: 40px;\n  mix-blend-mode: multiply;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      max-width: 100%;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 2px;\n  font-weight: ",
        ";\n  color: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  margin: 0;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  right: ",
        ";\n  top: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  border-radius: 1px;\n  height: 1em;\n  opacity: 0.25;\n  :not(:first-child) {\n    margin-top: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  float: right;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}




var padding = src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050;
var sharedInfoStyling = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject());
var ItemRow = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ItemRow",
    componentId: "sc-0-0"
})(_templateObject1(), padding);
var Icon = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Icon",
    componentId: "sc-0-1"
})(_templateObject2(), padding, function(p) {
    return p.border ? p.theme.bg.secondary : "transparent";
}, function(p) {
    return p.border ? "".concat(padding) : 0;
}, function(p) {
    return p.border ? "50%" : 0;
});
var SearchIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_magnifier__WEBPACK_IMPORTED_MODULE_2__/* .IconMagnifier */ .j).attrs({
    color: "base500"
}).withConfig({
    displayName: "SearchIcon",
    componentId: "sc-0-2"
})(_templateObject3());
var Image = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].img.withConfig({
    displayName: "Image",
    componentId: "sc-0-3"
})(_templateObject4());
var Info = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Info",
    componentId: "sc-0-4"
})(_templateObject5(), sharedInfoStyling);
var PlaceholderInfo = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "PlaceholderInfo",
    componentId: "sc-0-5"
})(_templateObject6(), sharedInfoStyling);
var Name = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({
    displayName: "Name",
    componentId: "sc-0-6"
})(_templateObject8(), function(p) {
    return p.bold ? "600" : "normal";
}, function(p) {
    return p.theme.text.primary;
}, function(p) {
    return(// Truncate list name if its too long
    p.truncate && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject7()));
});
var Count = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({
    displayName: "Count",
    componentId: "sc-0-7"
})(_templateObject9(), function(p) {
    return p.theme.colors.base500;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall);
var MoreMenu = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "MoreMenu",
    componentId: "sc-0-8"
})(_templateObject10(), padding, padding);
var PlaceHolderLineOfText = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "PlaceHolderLineOfText",
    componentId: "sc-0-9"
})(_templateObject11(), function(p) {
    return p.theme.colors.base300;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var PlaceHolderPriceChange = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(PlaceHolderLineOfText).withConfig({
    displayName: "PlaceHolderPriceChange",
    componentId: "sc-0-10"
})(_templateObject12(), function(param) {
    var isPositive = param.isPositive, theme = param.theme;
    return isPositive ? theme.colors.positive500 : theme.colors.negative700;
});
var CreateListIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_heart_outlined__WEBPACK_IMPORTED_MODULE_3__/* .IconHeartOutlined */ .G).attrs({
    color: "base300"
}).withConfig({
    displayName: "CreateListIcon",
    componentId: "sc-0-11"
})(_templateObject13());


/***/ }),

/***/ 27507:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ sort_button)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/dropdown-new/index.ts + 2 modules
var dropdown_new = __webpack_require__(13961);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/sort-button/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      border-bottom: 1px solid ",
        ";\n      border-top: 1px solid ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-bottom: ",
        ";\n\n  .ui-dropdown--header {\n    padding: 0;\n  }\n\n  .ui-dropdown--toggle-button {\n    padding: ",
        ";\n  }\n\n  .ui-dropdown--selected,\n  .ui-dropdown--toggle-button {\n    width: 100%;\n    text-align: left;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var padding = base/* layout.measurements.spacing050 */.bK.measurements.spacing050;
var styles_SortButton = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SortButton",
    componentId: "sc-0-0"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, padding, function(p) {
    return !p.$showBorder && (0,styled_components_browser_esm.css)(_templateObject(), p.theme.lines.primary, p.theme.lines.primary);
});

;// CONCATENATED MODULE: ./src/areas/sidebar/components/sort-button/index.tsx
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




var SortButton = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    _inherits(SortButton, _PureComponent);
    var _super = _createSuper(SortButton);
    function SortButton() {
        _classCallCheck(this, SortButton);
        return _super.apply(this, arguments);
    }
    var _proto = SortButton.prototype;
    _proto.defaultOption = function defaultOption() {
        var translationString = "sort.".concat(this.props.sort.name, ":").concat(this.props.sort.direction);
        var option = this.context.t("common", translationString);
        if (option === translationString) {
            return this.context.t("common", "sort.".concat(this.props.sort.name));
        }
        return option;
    };
    _proto.sortOptions = function sortOptions() {
        var _this = this;
        return this.props.sort.available ? this.props.sort.available.filter(function(x) {
            return x !== _this.props.sort.name;
        }).filter(function(x) {
            return x !== "".concat(_this.props.sort.name, ":").concat(_this.props.sort.direction);
        }).map(function(option) {
            return {
                name: _this.context.t("common", "sort.".concat(option)),
                value: option
            };
        }).filter(function(x) {
            return x.name !== "sort.".concat(x.value);
        }) : [];
    };
    _proto.onSelectHandler = function onSelectHandler(key) {
        var ref;
        var option = (ref = this.sortOptions()) === null || ref === void 0 ? void 0 : ref.find(function(x) {
            return x.value === key;
        });
        if (option && option.value) {
            this.props.onSelect(option);
        }
    };
    _proto.render = function render() {
        var _this = this;
        if (!this.props.sort.available || this.props.sort.available.length <= 1) {
            return null;
        }
        return /*#__PURE__*/ react.createElement(styles_SortButton, {
            $showBorder: this.props.showBorder
        }, /*#__PURE__*/ react.createElement(dropdown_new/* DropdownNew */.cw, {
            toggleElement: this.defaultOption(),
            onSelect: function(key) {
                return _this.onSelectHandler(key);
            },
            "data-test": "SortButtonDropdown",
            variant: "secondary"
        }, this.sortOptions().map(function(option) {
            return /*#__PURE__*/ react.createElement(dropdown_new/* ListItem */.HC, {
                key: option.value
            }, option.name);
        })));
    };
    return SortButton;
}(react.PureComponent);
SortButton.contextType = app_context/* AppContext */.Il;
/* harmony default export */ var sort_button = (SortButton);


/***/ }),

/***/ 58917:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ action_buttons_compare)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(25670);
;// CONCATENATED MODULE: ./src/components/action-buttons/compare/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    padding: ",
        ";\n    flex-grow: 0;\n    color: ",
        ";\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var CompareButton = (0,styled_components_browser_esm["default"])(variants.TextButton).withConfig({
    displayName: "CompareButton",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075, function(p) {
    return p.theme.text.primary;
}, function(p) {
    return p.theme.text.callToActionHover;
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(99816);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/compare/index.js
var compare = __webpack_require__(34645);
;// CONCATENATED MODULE: ./src/components/action-buttons/compare/index.tsx






var compare_CompareButton = function(param) {
    var products = param.products, buttonText = param.buttonText, buttonProps = param.buttonProps;
    var linkTo = (0,app_context/* useAppContext */.bp)().linkTo;
    var compareUrl = linkTo("productCompare", {
        products: products
    });
    return /*#__PURE__*/ react.createElement(CompareButton, {
        container: react_router_dom/* Link */.rU,
        containerProps: {
            to: compareUrl,
            onClick: buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onClick
        },
        onlyIcon: Boolean(buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onlyIcon)
    }, /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, null, /*#__PURE__*/ react.createElement(compare/* IconCompare */.P, null)), buttonText && /*#__PURE__*/ react.createElement(ui_button.ButtonText, null, buttonText));
};
/* harmony default export */ var action_buttons_compare = (compare_CompareButton);


/***/ }),

/***/ 32358:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": () => (/* binding */ ExpertUserLabel)
/* harmony export */ });
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21541);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25349);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94141);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96742);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    display: inline-flex;\n    align-items: center;\n    gap: ",
        ";\n    font-weight: normal;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Label = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_0__.BodySmallText).withConfig({
    displayName: "Label",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var Divider = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].span.withConfig({
    displayName: "Divider",
    componentId: "sc-0-1"
})(_templateObject1(), function(p) {
    return p.theme.text.quaternary;
});
/** The "| Expert" suffix shown after an expert user's name. */ var ExpertUserLabel = function(param) {
    var className = param.className;
    var t = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il).t;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(Label, {
        className: className,
        container: "span",
        flex: false
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(Divider, {
        "aria-hidden": "true"
    }, "|"), t("expert", "user.expert-label"));
};


/***/ }),

/***/ 98571:
/***/ ((module) => {

module.exports = "query getListById($listId: Int!, $listKey: String) {\n  getListById(listId: $listId, listKey: $listKey) {\n    createdAt\n    creatorId\n    description\n    id\n    itemCount\n    key\n    name\n    partnerList\n    theme {\n      backgroundColor {\n        hex\n      }\n      foregroundColor {\n        hex\n      }\n      url\n      name\n    }\n    type\n    visibility\n  }\n}"

/***/ })

}]);